import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { 
  Thermometer, Snowflake, Refrigerator, Zap, Droplets, Wrench,
  ArrowRight, CheckCircle, Star, Users, Clock, Search, Shield,
  Settings, AlertTriangle, PlusCircle, Trash2, WashingMachine, Microwave,
  Phone, Sparkles, BadgeCheck, TrendingUp, ChevronRight
} from 'lucide-react';

const ServicesPage = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const services = [
    {
      id: 'kombi',
      name: 'Kombi Servisi',
      icon: Thermometer,
      color: 'from-orange-500 to-red-500',
      bgColor: 'bg-orange-50',
      lightBg: 'bg-gradient-to-br from-orange-50 to-red-50',
      borderColor: 'border-orange-200',
      textColor: 'text-orange-600',
      description: 'Kombi bakım, arıza, montaj ve söküm işlemleri',
      longDesc: 'Tüm marka ve model kombiler için profesyonel bakım ve onarım hizmeti.',
      stats: { professionals: 247, rating: 4.9, jobs: '15K+' },
      popular: true,
      subServices: [
        { name: 'Kombi Bakımı', icon: Settings, desc: 'Periyodik bakım ve temizlik', price: '₺300-500' },
        { name: 'Kombi Arıza', icon: AlertTriangle, desc: 'Arıza tespiti ve onarım', price: '₺200-800' },
        { name: 'Kombi Montajı', icon: PlusCircle, desc: 'Yeni kombi kurulumu', price: '₺500-1000' },
        { name: 'Kombi Sökümü', icon: Trash2, desc: 'Eski kombi sökme', price: '₺200-400' },
        { name: 'Radyatör Tamiri', icon: Thermometer, desc: 'Petek arıza ve bakım', price: '₺150-400' },
      ]
    },
    {
      id: 'klima',
      name: 'Klima Servisi',
      icon: Snowflake,
      color: 'from-blue-500 to-cyan-500',
      bgColor: 'bg-blue-50',
      lightBg: 'bg-gradient-to-br from-blue-50 to-cyan-50',
      borderColor: 'border-blue-200',
      textColor: 'text-blue-600',
      description: 'Klima bakım, gaz dolumu, temizlik ve montaj',
      longDesc: 'Split, multi-split ve salon tipi klimalar için uzman servis.',
      stats: { professionals: 189, rating: 4.8, jobs: '12K+' },
      popular: true,
      subServices: [
        { name: 'Klima Bakımı', icon: Settings, desc: 'Filtre ve genel temizlik', price: '₺200-350' },
        { name: 'Gaz Dolumu', icon: Snowflake, desc: 'R410A/R32 gaz şarjı', price: '₺400-800' },
        { name: 'Klima Montajı', icon: PlusCircle, desc: 'Split klima kurulumu', price: '₺600-1200' },
        { name: 'Klima Sökümü', icon: Trash2, desc: 'Klima söküm işlemi', price: '₺200-400' },
        { name: 'Klima Arıza', icon: AlertTriangle, desc: 'Arıza tespiti ve onarım', price: '₺200-600' },
      ]
    },
    {
      id: 'beyaz_esya',
      name: 'Beyaz Eşya',
      icon: Refrigerator,
      color: 'from-teal-500 to-emerald-500',
      bgColor: 'bg-teal-50',
      lightBg: 'bg-gradient-to-br from-teal-50 to-emerald-50',
      borderColor: 'border-teal-200',
      textColor: 'text-teal-600',
      description: 'Tüm marka beyaz eşya tamir ve bakımı',
      longDesc: 'Buzdolabı, çamaşır makinesi, bulaşık makinesi ve daha fazlası.',
      stats: { professionals: 312, rating: 4.7, jobs: '20K+' },
      popular: true,
      subServices: [
        { name: 'Buzdolabı Tamiri', icon: Refrigerator, desc: 'Soğutma ve motor arızası', price: '₺200-800' },
        { name: 'Çamaşır Makinesi', icon: WashingMachine, desc: 'Yıkama ve sıkma arızası', price: '₺200-600' },
        { name: 'Bulaşık Makinesi', icon: Droplets, desc: 'Yıkama ve kurutma sorunu', price: '₺200-500' },
        { name: 'Fırın Tamiri', icon: Microwave, desc: 'Elektrik ve gaz fırın', price: '₺150-400' },
        { name: 'Kurutma Makinesi', icon: Settings, desc: 'Kurutma ve ısıtma sorunu', price: '₺200-500' },
      ]
    },
    {
      id: 'elektrik',
      name: 'Elektrik Servisi',
      icon: Zap,
      color: 'from-yellow-500 to-amber-500',
      bgColor: 'bg-yellow-50',
      lightBg: 'bg-gradient-to-br from-yellow-50 to-amber-50',
      borderColor: 'border-yellow-200',
      textColor: 'text-yellow-600',
      description: 'Elektrik arıza, tesisat ve aydınlatma işleri',
      longDesc: 'Ev ve işyeri için profesyonel elektrik hizmetleri.',
      stats: { professionals: 178, rating: 4.9, jobs: '10K+' },
      popular: false,
      subServices: [
        { name: 'Elektrik Arıza', icon: AlertTriangle, desc: 'Arıza tespiti ve onarım', price: '₺150-400' },
        { name: 'Priz/Anahtar', icon: Settings, desc: 'Priz ve anahtar montajı', price: '₺100-250' },
        { name: 'Aydınlatma', icon: Zap, desc: 'Avize ve spot montajı', price: '₺100-300' },
        { name: 'Sigorta Tamiri', icon: AlertTriangle, desc: 'Sigorta kutusu onarımı', price: '₺150-350' },
        { name: 'Kablo Çekimi', icon: Settings, desc: 'Yeni hat çekimi', price: '₺200-600' },
      ]
    },
    {
      id: 'su_tesisati',
      name: 'Su Tesisatı',
      icon: Droplets,
      color: 'from-cyan-500 to-blue-500',
      bgColor: 'bg-cyan-50',
      lightBg: 'bg-gradient-to-br from-cyan-50 to-blue-50',
      borderColor: 'border-cyan-200',
      textColor: 'text-cyan-600',
      description: 'Su kaçağı, tıkanıklık ve tesisat işleri',
      longDesc: 'Acil su tesisatı sorunlarınız için 7/24 hizmet.',
      stats: { professionals: 156, rating: 4.6, jobs: '8K+' },
      popular: false,
      subServices: [
        { name: 'Tıkanıklık Açma', icon: Settings, desc: 'Lavabo ve gider açma', price: '₺150-400' },
        { name: 'Su Kaçağı', icon: Droplets, desc: 'Kaçak tespiti ve onarım', price: '₺200-600' },
        { name: 'Musluk Tamiri', icon: Settings, desc: 'Musluk ve batarya değişimi', price: '₺100-300' },
        { name: 'Sıhhi Tesisat', icon: Wrench, desc: 'Boru döşeme ve onarım', price: '₺200-800' },
        { name: 'Termosifon', icon: Thermometer, desc: 'Şofben tamir ve montaj', price: '₺150-400' },
      ]
    },
    {
      id: 'genel',
      name: 'Diğer Hizmetler',
      icon: Wrench,
      color: 'from-slate-500 to-gray-600',
      bgColor: 'bg-gray-50',
      lightBg: 'bg-gradient-to-br from-slate-50 to-gray-100',
      borderColor: 'border-gray-200',
      textColor: 'text-gray-600',
      description: 'Ev için genel bakım ve onarım hizmetleri',
      longDesc: 'Mobilya montajı, boya badana ve küçük tadilat işleri.',
      stats: { professionals: 98, rating: 4.5, jobs: '5K+' },
      popular: false,
      subServices: [
        { name: 'Mobilya Montajı', icon: Settings, desc: 'Dolap ve mobilya kurulum', price: '₺100-400' },
        { name: 'Boya Badana', icon: Settings, desc: 'İç cephe boyama', price: '₺500-2000' },
        { name: 'Tadilat', icon: Wrench, desc: 'Küçük tadilat işleri', price: '₺300-1500' },
        { name: 'Cam/Çerçeve', icon: Settings, desc: 'Cam ve pencere işleri', price: '₺100-500' },
      ]
    }
  ];

  const categories = [
    { id: 'all', name: 'Tümü', count: services.length },
    { id: 'popular', name: 'Popüler', count: services.filter(s => s.popular).length },
    { id: 'isitma', name: 'Isıtma/Soğutma', count: 2 },
    { id: 'elektrik', name: 'Elektrik/Tesisat', count: 2 },
  ];

  const filteredServices = services.filter(service => {
    const matchesSearch = service.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         service.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         service.subServices.some(sub => sub.name.toLowerCase().includes(searchQuery.toLowerCase()));
    
    if (activeCategory === 'all') return matchesSearch;
    if (activeCategory === 'popular') return matchesSearch && service.popular;
    if (activeCategory === 'isitma') return matchesSearch && ['kombi', 'klima'].includes(service.id);
    if (activeCategory === 'elektrik') return matchesSearch && ['elektrik', 'su_tesisati'].includes(service.id);
    return matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-br from-[#006D77] via-[#0A9396] to-[#006D77] overflow-hidden">
        {/* Decorative */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
        
        <div className="max-w-6xl mx-auto px-4 relative z-10">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-5 py-2.5 mb-6">
              <Sparkles className="w-5 h-5 text-[#F6AD55]" />
              <span className="text-white font-semibold">1000+ Uzman Usta</span>
            </div>
            
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
              Tüm Ev Hizmetleri<br />
              <span className="text-[#F6AD55]">Tek Platformda</span>
            </h1>
            
            <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto">
              İhtiyacınız olan hizmeti seçin, onaylı ustalardan teklif alın
            </p>
          </div>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-2xl p-2 shadow-2xl flex items-center gap-2">
              <div className="flex-1 relative">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  type="text"
                  placeholder="Ne arıyorsunuz? (örn: kombi bakım, klima gaz)"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-12 pr-4 py-4 border-0 focus:ring-0 text-base rounded-xl"
                  data-testid="service-search-input"
                />
              </div>
              <Button 
                className="bg-[#006D77] hover:bg-[#005a63] text-white px-6 py-4 rounded-xl hidden sm:flex"
                data-testid="service-search-btn"
              >
                <Search className="w-5 h-5 mr-2" />
                Ara
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="py-6 bg-white border-b sticky top-0 z-40 shadow-sm">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`flex-shrink-0 px-5 py-2.5 rounded-full font-medium text-sm transition-all ${
                  activeCategory === cat.id
                    ? 'bg-[#006D77] text-white shadow-lg'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
                data-testid={`category-${cat.id}`}
              >
                {cat.name}
                <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${
                  activeCategory === cat.id ? 'bg-white/20' : 'bg-gray-200'
                }`}>
                  {cat.count}
                </span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4">
          {filteredServices.length === 0 ? (
            <div className="text-center py-16">
              <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Search className="w-10 h-10 text-gray-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Sonuç bulunamadı</h3>
              <p className="text-gray-500">"{searchQuery}" için hizmet bulunamadı. Farklı bir arama deneyin.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredServices.map((service) => {
                const Icon = service.icon;
                
                return (
                  <div
                    key={service.id}
                    className="group bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-2xl transition-all duration-500 overflow-hidden"
                    data-testid={`service-card-${service.id}`}
                  >
                    {/* Card Header */}
                    <div className={`${service.lightBg} p-6 relative overflow-hidden`}>
                      {service.popular && (
                        <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-400 to-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1">
                          <TrendingUp className="w-3 h-3" />
                          Popüler
                        </div>
                      )}
                      
                      <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                        <Icon className="w-8 h-8 text-white" />
                      </div>
                      
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h3>
                      <p className="text-gray-600 text-sm">{service.longDesc}</p>
                    </div>

                    {/* Stats */}
                    <div className="px-6 py-4 border-b border-gray-100">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                          <div className="flex items-center gap-1.5">
                            <Users className="w-4 h-4 text-gray-400" />
                            <span className="text-sm font-medium text-gray-700">{service.stats.professionals}</span>
                          </div>
                          <div className="flex items-center gap-1.5">
                            <Star className="w-4 h-4 text-amber-400 fill-amber-400" />
                            <span className="text-sm font-medium text-gray-700">{service.stats.rating}</span>
                          </div>
                        </div>
                        <div className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                          {service.stats.jobs} iş
                        </div>
                      </div>
                    </div>

                    {/* Sub Services Preview */}
                    <div className="px-6 py-4">
                      <p className="text-xs text-gray-500 font-medium mb-3">Popüler Hizmetler:</p>
                      <div className="flex flex-wrap gap-2">
                        {service.subServices.slice(0, 3).map((sub, idx) => (
                          <span 
                            key={idx}
                            className={`text-xs ${service.bgColor} ${service.textColor} px-3 py-1.5 rounded-full font-medium`}
                          >
                            {sub.name}
                          </span>
                        ))}
                        {service.subServices.length > 3 && (
                          <span className="text-xs bg-gray-100 text-gray-500 px-3 py-1.5 rounded-full">
                            +{service.subServices.length - 3} daha
                          </span>
                        )}
                      </div>
                    </div>

                    {/* CTA */}
                    <div className="px-6 pb-6">
                      <Button
                        onClick={() => navigate(`/servis-talep/${service.id}`)}
                        className={`w-full bg-gradient-to-r ${service.color} hover:opacity-90 text-white rounded-xl py-3 font-semibold group-hover:shadow-lg transition-all`}
                        data-testid={`service-cta-${service.id}`}
                      >
                        Hizmet Al
                        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Quick Services */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Hızlı Hizmet Seçimi
            </h2>
            <p className="text-gray-600">En çok talep edilen hizmetlere hızlıca ulaşın</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { name: 'Kombi Bakımı', icon: Thermometer, color: 'from-orange-500 to-red-500', id: 'kombi' },
              { name: 'Klima Gazı', icon: Snowflake, color: 'from-blue-500 to-cyan-500', id: 'klima' },
              { name: 'Buzdolabı Tamiri', icon: Refrigerator, color: 'from-teal-500 to-emerald-500', id: 'beyaz_esya' },
              { name: 'Elektrik Arıza', icon: Zap, color: 'from-yellow-500 to-amber-500', id: 'elektrik' },
              { name: 'Su Kaçağı', icon: Droplets, color: 'from-cyan-500 to-blue-500', id: 'su_tesisati' },
              { name: 'Çamaşır Makinesi', icon: WashingMachine, color: 'from-purple-500 to-pink-500', id: 'beyaz_esya' },
              { name: 'Tıkanıklık Açma', icon: Wrench, color: 'from-gray-500 to-slate-600', id: 'su_tesisati' },
              { name: 'Fırın Tamiri', icon: Microwave, color: 'from-rose-500 to-red-500', id: 'beyaz_esya' },
            ].map((item, idx) => {
              const ItemIcon = item.icon;
              return (
                <button
                  key={idx}
                  onClick={() => navigate(`/servis-talep/${item.id}`)}
                  className="group bg-white rounded-2xl p-4 md:p-6 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 text-left"
                  data-testid={`quick-service-${idx}`}
                >
                  <div className={`w-12 h-12 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                    <ItemIcon className="w-6 h-6 text-white" />
                  </div>
                  <h4 className="font-semibold text-gray-900 text-sm md:text-base mb-1">{item.name}</h4>
                  <div className="flex items-center gap-1 text-[#006D77] text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                    Talep Oluştur <ChevronRight className="w-3 h-3" />
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Neden HizmetGeliyo?
            </h2>
            <p className="text-gray-600">Binlerce müşteri bizi tercih ediyor</p>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: BadgeCheck, title: 'Onaylı Ustalar', desc: 'Tüm ustalar kimlik doğrulamalı', color: 'text-green-600', bg: 'bg-green-50' },
              { icon: Shield, title: '30 Gün Garanti', desc: 'Her hizmet garantili', color: 'text-blue-600', bg: 'bg-blue-50' },
              { icon: Clock, title: 'Hızlı Hizmet', desc: 'Aynı gün randevu imkanı', color: 'text-purple-600', bg: 'bg-purple-50' },
              { icon: Star, title: '4.8+ Puan', desc: 'Yüksek müşteri memnuniyeti', color: 'text-amber-600', bg: 'bg-amber-50' },
            ].map((item, idx) => {
              const ItemIcon = item.icon;
              return (
                <div key={idx} className="text-center p-6 rounded-2xl hover:shadow-lg transition-shadow">
                  <div className={`w-16 h-16 ${item.bg} rounded-2xl flex items-center justify-center mx-auto mb-4`}>
                    <ItemIcon className={`w-8 h-8 ${item.color}`} />
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-sm">{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-[#006D77] to-[#0A9396] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2"></div>
        
        <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">
            Aradığınız hizmeti bulamadınız mı?
          </h2>
          <p className="text-white/80 text-lg mb-8">
            Bizi arayın, ihtiyacınıza uygun ustayı bulalım
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:08502427808"
              className="inline-flex items-center justify-center gap-3 bg-white text-[#006D77] px-8 py-4 rounded-full font-bold text-lg hover:shadow-xl transition-all"
              data-testid="call-cta"
            >
              <Phone className="w-5 h-5" />
              0850 242 78 08
            </a>
            <Button
              onClick={() => navigate('/iletisim')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#006D77] px-8 py-4 rounded-full font-bold text-lg"
              data-testid="contact-cta"
            >
              İletişime Geç
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
